import * as React from 'react';
export const fondoSvg = React.forwardRef(function fondoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#002F88',
      fillRule: 'evenodd',
      d: 'M6.069 13.35a.641.641 0 0 1 .25-.872L21.467 4.08c.31-.172.7-.06.872.25l1.037 1.87c.172.31.06.7-.25.872L7.978 15.47c-.31.172-.7.06-.872-.25l-1.037-1.87Zm2.592 4.675a.641.641 0 0 1 .25-.872l15.148-8.397c.31-.171.7-.06.872.25l1.037 1.87c.171.31.06.7-.25.873l-15.149 8.396c-.31.172-.7.06-.872-.25l-1.036-1.87ZM5.33 25.25a.641.641 0 0 0-.25.872l1.036 1.87c.172.31.562.422.872.25l15.149-8.397a.642.642 0 0 0 .25-.872l-1.037-1.87a.642.642 0 0 0-.872-.25L5.331 25.25Z',
      clipRule: 'evenodd',
    }),
  );
});
fondoSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var fondo = {
  category: 'brand',
  colorable: false,
  name: 'fondo',
  svg: fondoSvg,
};
